
import api from "@/api/index"; //ABP API接口
import { Vue, Component, Ref } from "vue-property-decorator";
import { ElementTableView } from "@/lib/ElementTableView";

import { MessageBox } from "element-ui";
import enumFilter from "@/mixins/filters/enums";

import { ActivityApplyDto } from "@/api/appService";
import RefundDialog from "@/components/RefundDialog/index.vue";
@Component({
  name: "ApplyList",
  mixins: [enumFilter],
  components: { RefundDialog }
})
export default class ApplyList extends ElementTableView {
  @Ref() refundDialog!: RefundDialog;
  tableItems: ActivityApplyDto[] = [];

  activityId: number | undefined = undefined;

  async created() {
    console.log(this.$route.params);

    if (this.$route.params && this.$route.params.activityId)
      this.activityId = parseInt(this.$route.params.activityId) || undefined;
    await this.fetchData();
  }

  private tagColor(status: any) {
    switch (status) {
      case 5:
        return "info";
      case 6:
      case 0:
      case 4:
        return "";
      case 10:
        return "success";
      case -1:
      case -2:
      case 1:
        return "danger";
      default:
        return "";
    }
  }

  queryForm: any = {
    keyword: "",
    title: undefined,
    from: undefined,
    to: undefined,
    isActive: undefined
  };

  // 获取表数据
  async fetchData() {
    this.table.listLoading = true;
    await api.activityApply
      .getAll({
        activityId: this.activityId,
        title: this.queryForm.title,
        keyword: this.queryForm.keyword,
        isActive: this.queryForm.isActive,
        sorting: this.table.sorting,
        from: this.queryForm.from,
        to: this.queryForm.to,
        skipCount: this.skipCount,
        maxResultCount: this.table.pagesize
      })
      .then(res => {
        console.log(res);
        this.table.listLoading = false;
        this.tableItems = res.items!;
        this.table.totalCount = res.totalCount!;
      });
  }

  // 删除
  async handleDelete(index: number, row: ActivityApplyDto) {
    this.$confirm("你确定删除吗?", "提示").then(async () => {
      await api.activityApply.delete({ id: row.id }).then(res => {
        this.$message({
          type: "success",
          message: "删除成功!"
        });
        this.fetchData();
      });
    });
  }

  // 更新当前页
  async current_change(e: number) {
    this.table.page = e;
    await this.fetchData();
  }

  // Table排序
  async sort(e: any) {
    console.log("sort : ", e);
    if (e.prop && e.order) {
      this.table.sorting = `${e.prop} ${e.order}`;
    }
    await this.fetchData();
  }

  // 修改一页显示的条目
  async handleSizeChange(e: number) {
    this.table.pagesize = e;
    await this.fetchData();
  }

  // 搜索
  async handleSearch() {
    await this.fetchData();
  }

  // 重置搜索
  async handleResetSearch() {
    this.queryForm = {
      keyword: "",
      from: undefined,
      to: undefined,
      isActive: undefined
    };
    await this.fetchData();
  }

  // 申请退款
  async handleRefund(item: ActivityApplyDto) {
    console.log(this.refundDialog);
    (this.refundDialog as any).defaultValue = item.totalPaid;
    (this.refundDialog as any).row = item;
    (this.refundDialog as any).show = true;
  }

  async refundSubmit(event: { row: ActivityApplyDto; refundValue: number,desc:string, auditFlowId:string }) {
    console.log(event);
    await api.activity
      .refund({
        id: event.row.id as number,
        totalPrice: event.refundValue,
        desc:event.desc,
        auditFlowId:event.auditFlowId })
      .then(res => {
        this.$message.success('退款申请已提交，请等待审核');
        this.fetchData();
      });
  }

  async handelOnSaved() {
    await this.fetchData();
  }
}
